import React from 'react';
import { SubmitHandler, useFormContext } from 'react-hook-form';
import { logger } from '@adac-de/e-charge-common';
import { PartnerOfferingForm } from './offer-form-second';
import { isWizardDataType } from 'types';

type ValidPartnerOfferingForm = Omit<PartnerOfferingForm, 'allPartners'>;

type OfferFormWrapperProps = {
  solarPartnersRequestData: WizardDataType;
  submit: (data: FormDataType, wizardData: WizardDataType) => void;
};

export const OfferFormWrapper: React.FC<React.PropsWithChildren<OfferFormWrapperProps>> = ({
  solarPartnersRequestData,
  submit,
  children
}) => {
  const { handleSubmit } = useFormContext<PartnerOfferingForm>();

  const onSubmit: SubmitHandler<ValidPartnerOfferingForm> = (data: ValidPartnerOfferingForm) => {
    const filteredWizardData = Object.fromEntries(
      Object.entries(solarPartnersRequestData).filter(([key]) => key !== '__typename')
    );

    if (isWizardDataType(filteredWizardData)) {
      submit(data, filteredWizardData);
    } else {
      logger.error('Invalid WizardDataType in filteredWizardData');
    }
  };

  return (
    <form onSubmit={handleSubmit(({ allPartners, ...rest }) => onSubmit(rest))} noValidate>
      {children}
    </form>
  );
};
